import { RadiusType } from '../models/coordinate.model';

export const getRadius = (value: number | null | undefined, type: RadiusType): number | null => {
    if (value) {
        return type === RadiusType.Meters ? value * 1000 : value / 1000;
    }

    return null;
};

export const isId = (value: string): boolean => value.toLocaleLowerCase().includes('id:');
